import { Outlet, Link } from "react-router-dom";
import { useEffect } from "react";
import './Layout.css';

const Layout = () => {

  useEffect(() => {
    // LinkedIn Insight Tag
    window._linkedin_partner_id = "7373476";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

    // LinkedIn tracking script loader
    (function(l) {
        if (!l) {
            window.lintrk = function(a, b) {
                window.lintrk.q.push([a, b]);
            };
            window.lintrk.q = [];
        }
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
    })(window.lintrk);

    // Fallback tracking pixel for environments without JavaScript
    var img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = 'https://px.ads.linkedin.com/collect/?pid=7373476&fmt=gif';
    // Add fallback pixel to body
    document.body.appendChild(img);
  }, []);

  return (
    <>

	<header>
	  <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-black">
	    <div className="container-fluid">
	      <Link to="/" className="navbar-brand" href="#about" id="link-logo" onClick="load_page(this)" data-content="content/about"><img alt="Saigon A.I. Company Limited [Logo]" src="/img/sgai_logo_black.png" width="120"/></Link>
	      <button className="navbar-toggler" type="button" aria-controls="navbarHB" aria-expanded="false" aria-label="Toggle navigation"
		  		data-bs-toggle="collapse" 
				data-bs-target="#navbarHB">
	        <span className="navbar-toggler-icon"></span>
	      </button>
	      <div className="collapse navbar-collapse" id="navbarHB">
	        <ul className="navbar-nav me-auto mb-2 mb-md-0">
	          <li className="nav-item">
	            <a className="nav-link active" aria-current="page" href="/">Home</a>
	          </li>
	          <li className="nav-item">
	            <a className="nav-link" href="https://blog.saigonai.com">Blog</a>
	          </li>
			  <li className="nav-item">
	            <Link to="/press" className="nav-link">Press</Link>
	          </li>
	          <li className="nav-item d-md-none">
	            <Link to="/contact" className="nav-link">Contact</Link>
	          </li>
			</ul>
            <Link to="/contact" className="btn btn-warning d-none d-md-block">Contact</Link>
		  </div>
	    </div>
	  </nav>
	</header>


	<main className="d-flex flex-nowrap">	
		<div className="container d-flex flex-column flex-shrink-0 p-3 ">
		    <div className="row">
		        <div className="col-2">
                    <div className="nav flex-column nav-pills" id="nav-pills" role="tablist" aria-orientation="vertical">                
                        <Link to="/" className="btn btn-sgai-nav" id="v-pills-home-tab" data-toggle="pill"  type="button">
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-house"></i>Start Here</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-house"></i></span>
                        </Link>
                        <Link to="/solutions" className="btn btn-sgai-nav" id="v-pills-usecase-tab" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-paper-plane"></i>What We Do</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-paper-plane"></i></span>
                        </Link>
                        <Link to="/about/process" className="btn btn-sgai-nav" id="v-pills-usecase-tab" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-coffee"></i>How We Work</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-coffee"></i></span>
                        </Link>
                        <Link to="/capabilities" className="btn btn-sgai-nav" href="#nav-capabilities" id="v-pills-usecase-tab" data-content="content/capabilities" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-flask"></i>Capabilities</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-flask"></i></span>
                        </Link>
                        <Link to="/about/culture" className="btn btn-sgai-nav" href="#nav-culture" id="v-pills-usecase-tab" data-content="content/culture" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-leaf"></i>Culture</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-leaf"></i></span>
                        </Link>
                        <Link to="/about/story" className="btn btn-sgai-nav" href="#nav-story" id="v-pills-usecase-tab" data-content="content/story" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-bicycle"></i>Our Story</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-bicycle"></i></span>
                        </Link>
                        <Link to="/learn" className="btn btn-sgai-nav" href="#nav-learn" id="v-pills-usecase-tab" data-content="content/learn" data-toggle="pill"  type="button" role="tab"  >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-university"></i>Learn</span>
                            <span className="disableSpan d-lg-none"><i className="fa-fw fa-solid fa-university"></i></span>
                        </Link>
                        <Link to="/jobs" className="btn btn-sgai-nav" href="#nav-jobs" id="v-pills-usecase-tab" data-content="content/jobs" data-toggle="pill"  type="button" role="tab" >
                            <span className="disableSpan d-none d-lg-block" ><i className="fa-fw fa-sm fa-solid fa-users"></i>Join Our Team</span>
                            <span className="disableSpan d-lg-none" ><i className="fa-fw fa-solid fa-users"></i></span>
                        </Link>
                    </div>
		        </div>
                <div className="col-10">
                    <Outlet />
					<p>&nbsp;</p>
					<p>&nbsp;</p>
                </div>
		    </div>
	    </div>
	</main>	


    <footer className="footer mt-auto py-3 bg-black d-flex flex-column flex-sm-row justify-content-between fixed-bottom">
	    <div className="col-md-4 d-flex align-items-center">
	      <span className="mb-3 mb-md-0 text-body-secondary white d-none d-md-block">
	      &copy; 2018-{(new Date().getFullYear())} Saigon A.I. Company Limited
	      </span>
	    </div>
	
	    <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
	      <li className="ms-3"><a className="text-body-secondary white" href="https://www.linkedin.com/company/saigonai"><i className="fab fa-fw fa-linkedin-in"></i></a></li>
	      <li className="ms-3"><a className="text-body-secondary white" href="https://www.facebook.com/SaigonAi.4U"><i className="fab fa-fw fa-facebook-f"></i></a></li>
	      <li className="ms-3" ><a className="text-body-secondary white" href="mailto:info@saigonai.com"><i className="fa-solid fa-fw fa-envelope"></i>info@saigonai.com</a></li>
	      <li>&nbsp;</li>
	    </ul>	    
	</footer>

    </>
  )


};



export default Layout;